import { createContext } from 'react';

export const ReplicaContext = createContext<ReplicaContextProps>({
	isMenuOpen: false,
	setIsMenuOpen: () => {},
	isTocOpen: false,
	setTocOpen: () => {},
	toggleToc: () => {},
	toggleMenu: () => {},
	setViewMode: () => {},
});

interface ReplicaContextProps {
	isMenuOpen: boolean;
	setIsMenuOpen: (value: boolean) => void;
	toggleMenu: () => void;
	isTocOpen: boolean;
	setTocOpen: (value: boolean) => void;
	toggleToc: () => void;
	setViewMode: (value: 'single' | 'double') => void;
}
